import { render, staticRenderFns } from "./xeAlarmHistoryWidget.vue?vue&type=template&id=2ffd2c03&scoped=true"
import script from "./xeAlarmHistoryWidget.vue?vue&type=script&lang=js"
export * from "./xeAlarmHistoryWidget.vue?vue&type=script&lang=js"
import style0 from "./xeAlarmHistoryWidget.vue?vue&type=style&index=0&id=2ffd2c03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd2c03",
  null
  
)

export default component.exports